import Reveal from "@/components/base/Reveal";
import { directions, stats } from "@/mocks/siteData";

export default function Directions() {
  return (
    <section id="directions" className="bg-background-100 py-16 md:py-24 scroll-mt-20">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <Reveal>
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-xs font-medium tracking-widest text-primary-600 uppercase">
              <span className="w-6 h-px bg-primary-400"></span>
              核心方向
            </span>
            <h2 className="mt-4 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
              四个观看方向，先弄清各自解决什么问题
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              在线观看、免费观看、高清播放与手机在线，并不是同一件事的四种说法，而是分别对应不同的使用场景。
              先看完下面的差别，再去片单里筛选，会更省事。
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {directions.map((item, idx) => (
            <Reveal key={item.title} delay={idx * 80}>
              <article className="h-full bg-background-50 rounded-lg border border-background-200 p-5 md:p-6 transition-shadow hover:border-primary-300 cursor-default">
                <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-700 mb-5">
                  <i className={`${item.icon} text-2xl`} aria-hidden="true"></i>
                </div>
                <h3 className="font-heading text-lg font-semibold text-foreground-950">{item.title}</h3>
                <p className="mt-1 text-xs text-secondary-600 tracking-wide">{item.keyword}</p>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{item.summary}</p>
                <ul className="mt-5 pt-5 border-t border-background-200 space-y-2.5">
                  {item.points.map((p) => (
                    <li key={p} className="flex items-start gap-2 text-sm text-foreground-700">
                      <i className="ri-check-line text-accent-600 mt-0.5 shrink-0" aria-hidden="true"></i>
                      <span>{p}</span>
                    </li>
                  ))}
                </ul>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={120}>
          <div className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-px bg-background-200 rounded-lg overflow-hidden border border-background-200">
            {stats.map((s) => (
              <div key={s.label} className="bg-background-50 px-5 py-6 md:px-6 md:py-7">
                <i className={`${s.icon} text-xl text-secondary-500`} aria-hidden="true"></i>
                <p className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950">{s.value}</p>
                <p className="mt-1 text-xs md:text-sm text-foreground-500">{s.label}</p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}